import { gql } from "@/__generated__/gql";

export const RISE_YIELD_INDEX_SUMMARY = gql(`
query riseYieldIndexSummary($orgId: ID!, $cohortYear: Int!, $inCommunity: YesNoEnum) {
  node(id: $orgId) {
    id
    ... on Organization {
      rise {
        yieldIndexSummary(cohortYear: $cohortYear, inCommunity: $inCommunity) {
          low {
            state
            value
          }
          mediumLow {
            state
            value
          }
          medium {
            state
            value
          }
          mediumHigh {
            state
            value
          }
          high {
            state
            value
          }
        }
      }
    }
  }
}
`);
